export const HttpStatus = {
	Success: 200,
	Unauthorize: 401,
	Forbidden: 403,
	NotFound: 404,
	InternalError: 500,
};

export const ApiResultErrorException = "ApiResultErrorException";
